import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	root: {
		backgroundColor: "#440067",
		color: "#ffffff",
		height: 44,
		width: 335,
		fontSize: 12,
		fontWeight: "normal",
		textTransform: "none",
		borderRadius: 20,
		"&:hover": {
			backgroundColor: "#106ba3",
		},
	},
}));
